export const FileStatus = {
	INIT: 'init',
	ADDED: 'added',
	LOADING: 'loading',
	PENDING: 'pending',
	UPLOADING: 'uploading',
	COMPLETE: 'complete',
	//REMOVING: 'removing',
	//REMOVE_FAILED: 'remove-failed',
	LOAD_FAILED: 'load-failed',
	UPLOAD_FAILED: 'upload-failed',
};